import React from 'react';
import DesignOptionFilterForm from '../DesignOptionFilterForm';
import enhance from './enhance';

const TrimOptionFilters = ({
  options,
  trimFormPlaceHolder,
  setActiveFilters,
  activeFilters,
  clearFilter,
}) => {
  return (
    <DesignOptionFilterForm
      options={options}
      placeHolder={trimFormPlaceHolder}
      setActiveFilters={setActiveFilters}
      filterName="trimOption"
      activeFilters={activeFilters}
      clearFilter={clearFilter}
    />
  );
};

export default enhance(TrimOptionFilters);
